export const scrollToProductRequiredSection = () => {
    const headerOffset = 94;
    const modals = document.querySelectorAll('#product-modal');

    if (modals.length > 0) {
        const lastModal = modals[modals.length - 1];
        const errorElements = lastModal.querySelectorAll('.badge-danger-light');

        if (errorElements[0]) {
            const scrollContainer = lastModal.closest('.modal');

            if (scrollContainer) {
                const targetTop = errorElements[0].getBoundingClientRect().top + scrollContainer.scrollTop - headerOffset;
                scrollContainer.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });
            }

            const parent = errorElements[0].parentElement;
            const textElement = parent?.querySelector("p");

            parent?.classList.add("alert", "alert-danger");
            textElement?.classList.replace("text-muted", "text-danger");
        }
    }
};